module.exports = __webpack_public_path__ + "media/images/sp/specials/common/event/event_couple_photo-7f21ff9cd06e318d534d071e74d61d3a.jpg";